import { Reveal } from "./Reveal";

const SCRIPTURE_BG = "https://images.unsplash.com/photo-1749743185998-9366c6869c08?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

const verses = [
  {
    text: "Who changed the truth of God into a lie, and worshipped and served the creature more than the Creator.",
    ref: "Romans 1:25",
  },
  {
    text: "But even if we or an angel from heaven should preach to you a gospel contrary to the one we preached to you, let him be accursed.",
    ref: "Galatians 1:8",
  },
];

export const Scripture = () => (
  <section id="scripture" data-testid="scripture-section" className="relative py-28 md:py-40 overflow-hidden">
    <div className="absolute inset-0">
      <img src={SCRIPTURE_BG} alt="An open book by candlelight" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#0A0A0A]/88" />
    </div>

    <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
      <Reveal>
        <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#D4AF37] mb-16">
          The Word Stands Forever
        </p>
      </Reveal>

      <div className="space-y-24">
        {verses.map((v, i) => (
          <Reveal key={v.ref} delay={i * 0.1}>
            <figure data-testid={`scripture-${i}`}>
              <span className="font-heading text-6xl md:text-8xl text-[#D4AF37]/30 leading-none select-none">
                &ldquo;
              </span>
              <blockquote className="font-heading font-light italic text-3xl md:text-5xl leading-tight text-[#F4F0EA] -mt-6">
                {v.text}
              </blockquote>
              <figcaption className="mt-8 font-mono text-sm tracking-[0.2em] uppercase text-[#D4AF37]">
                — {v.ref}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
